// INIT OBJECT PRODUCT PAGE
/*

  product
    |
    +-- SLIDER VISUAL PRODUCT
    |
    +-- NAV SLIDER VISUAL PRODUCT
    |
    +-- MODAL PRODUCT HANDLER
    |
    +-- MODAL DELIVERY PRODUCT
    |
    +-- PRODUCTS BENEFITS
    |
    +-- SLICK VIDEO
    |
    +-- SCROLLMAGIC
    |
    +-- ION.RANGESLIDER

*/

import { clearCheckStatusTimer as clearQrCodeCheckStatusTimer } from '@/checkout/payment/payment-qrcode';

export function init() {

  window.decathlon.product = {};
  window.decathlon.product.init = () => {
    const mainSliderWrapper = $('.slick-pp-product-visual');
    const mainSlickNavWrapper = $('.slider-nav-product-visual');


    const mainSlickNavSettings = {
      slidesToShow: 7,
      infinite: false,
      slidesToScroll: 1,
      useCSS: true,
      focusOnSelect: true,
      variableWidth: true,
      useTransform: true,
      draggable: false,
      responsive: [
        {
          breakpoint: window.decathlon.uxBreakpoints.smMin,
          settings: {
            arrows: true,
            infinite: false,
            variableWidth: true,
            speed: 200,
            slidesToShow: 6,
            slidesToScroll: 2,
            swipe: true,
            draggable: false,
            swipeToSlide: true
          }
        }
      ]
    };

    $('#sticker-display-div').children().addClass('product-details');

    const makeYourChoiceBtn = $('#modal-product-cta');
    const productHeader = $('#header-pp .product-head');
    let theDesktopProductHeaderIsSticky = false;

    mainSlickNavWrapper.slick(mainSlickNavSettings);

    if (mainSlickNavWrapper.length) {
      const modelImgs = mainSlickNavWrapper[0].$$('.slick-slide img');
      let loadedModelImgs = 0;

      const addToggler = () => {
        const containerWidth = mainSlickNavWrapper[0].$('.slick-track').offsetWidth;
        let contenantWidth = 0;

        [].forEach.call(mainSlickNavWrapper[0].$$('.slick-slide'), (slide) => {
          contenantWidth += $(slide).outerWidth(true);
        });

        if (contenantWidth > containerWidth)
          mainSlickNavWrapper.find('.slick-track').append('<div class="toggle-colors icon"></div>');
      };

      const imgIsLoaded = () => {
        loadedModelImgs += 1;
        if (loadedModelImgs === modelImgs.length)
          addToggler();
      };

      modelImgs.forEach((img) => {
        const imgObject = new Image();
        imgObject.addEventListener('load', imgIsLoaded);
        imgObject.src = img.src;
      });

    }

    const indexOfSelectedColor = mainSliderWrapper.slick('slickCurrentSlide');

    mainSliderWrapper.on({
      beforeChange(event, slick, current_slide_index, next_slide_index) {
        $('.conversion-zone .thumbs-product-list .slick-slide').removeClass('slick-current');
        $(`.conversion-zone .thumbs-product-list .slick-slide[data-slick-index=${next_slide_index}]`).addClass('slick-current');
        window.decathlon.product.addAnalytiContentcUrl();
      }
    }).slick('slickGoTo', indexOfSelectedColor, true);


    /* HEADER ON SCROLL */
    //NOT-DEAD
    const stickProductHead = () => {
      const htmlTag = $('html');
      const scroll = $(window).scrollTop();
      const htmlStickyClass = 'product-head-sticky';
      const hideProductHeaderClass = 'phs-off';
      const showProductHeaderClass = 'phs-on';
      const breakPointScrollStickyHeader = cube.$('#container-top') ? cube.$('#container-top').offsetHeight : 500;

      const calculateElemPos = () => {
        const buttons = cube.$('.buying-zone .cart-buttons');
        const buttonsWidth = buttons.offsetWidth;
        const buttonsRightPos = parseInt(window.getComputedStyle(buttons).getPropertyValue('right'), 10);

        const priceTag = cube.$('.product-price-and-button');
        const productHead = cube.$('#product-head');

        priceTag.style.right = `${buttonsWidth + buttonsRightPos + 5}px`;
        productHead.style.paddingRight = `${buttonsWidth + buttonsRightPos + priceTag.offsetWidth + 5}px`;
      };

      const addHTMLStickyClass = () => {
        if (!htmlTag.hasClass(htmlStickyClass)) {
          htmlTag.addClass(htmlStickyClass);
          cube.$id('container-top').style.height = `${breakPointScrollStickyHeader}px`;
          cube.$('.description-product-nav__layout').classList.add('description-product-nav__layout--fixed');
          if (!document.querySelector('html').classList.contains('mobile')) {
            calculateElemPos();
          }
        }
      };

      const removeHTMLStickyClass = () => {
        if (htmlTag.hasClass(htmlStickyClass)) {
          htmlTag.removeClass(htmlStickyClass);
          cube.$id('container-top').style.height = null;
          cube.$('.description-product-nav__layout').classList.remove('description-product-nav__layout--fixed');
        }
      };

      const addHTMLStickyAnimationClass = () => {
        if (htmlTag.hasClass(hideProductHeaderClass) && !htmlTag.hasClass(showProductHeaderClass)) {
          htmlTag.removeClass(hideProductHeaderClass).addClass(showProductHeaderClass);
        }
      };

      const removeHTMLStickyAnimationClass = () => {
        if (!htmlTag.hasClass(hideProductHeaderClass)) {
          htmlTag.addClass(hideProductHeaderClass);
        }

        if (htmlTag.hasClass(showProductHeaderClass)) {
          htmlTag.removeClass(showProductHeaderClass);
        }
      };

      const addMakeYourChoiceBtnSmallClass = () => {
        if (!makeYourChoiceBtn.hasClass('small')) {
          makeYourChoiceBtn.addClass('small');
        }
      };

      const removeMakeYourChoiceBtnSmallClass = () => {
        if (makeYourChoiceBtn.hasClass('small')) {
          makeYourChoiceBtn.removeClass('small');
        }
      };

      if (window.decathlon.uxBreakpoints.is('large-screen')) {
        if (scroll < breakPointScrollStickyHeader) {

          if (theDesktopProductHeaderIsSticky === true) {

            removeHTMLStickyAnimationClass();

            setTimeout(() => {
              removeHTMLStickyClass();
              removeMakeYourChoiceBtnSmallClass();
            }, 100);

            theDesktopProductHeaderIsSticky = false;

          }

        } else if (theDesktopProductHeaderIsSticky === false) {

          addHTMLStickyClass();
          addMakeYourChoiceBtnSmallClass();
          addHTMLStickyAnimationClass();

          theDesktopProductHeaderIsSticky = true;

        }

      } else if (window.decathlon.uxBreakpoints.is('small-screen')) {
        if (scroll < $('#main-container').offset().top) {
          removeHTMLStickyClass();
        } else {
          addHTMLStickyClass();
        }
      }
    };

    if (productHeader.length > 0) {
      $(window).on('load', stickProductHead);
      $(window).on('resize', cube.debounce(stickProductHead, 100));
      $(window).on('scroll', cube.debounce(stickProductHead, 100));
    }


    window.decathlon.tools.multipleDropdown();

    $('.modal-multibuy').detach().appendTo('body');

    /* MODAL DELIVERY PRODUCT */
    $('#modal-delivery, #modal-multibuy, #modal-stock').on('shown.bs.modal', (event) => {

      if ($(event.relatedTarget).hasClass('see-more-stores')) {
        $('#modal-delivery .see-delivery, #delivery').removeClass('active');
        $('#modal-delivery .see-pick-up, #pickup').addClass('active');
      }
      if ($(event.relatedTarget).hasClass('change')) {
        $('#modal-delivery .see-pick-up, #pickup').removeClass('active');
        $('#modal-delivery .see-delivery, #delivery').addClass('active');
      }

    });

    /* THE PRODUCT AND AMBIANCE PICTURES CAROUSEL */
    /*

    /* --- */

    const containerFloorProductPictures = $('.floor-pictures .slick-pp-pictures-img');

    containerFloorProductPictures.on('init reInit', () => {
      setTimeout(() => {
        containerFloorProductPictures.slick('setPosition');
      }, 500);
    });

    containerFloorProductPictures.slick({
      centerMode: true,
      useCSS: true,
      useTransform: true,
      variableWidth: true,
      responsive: [{
        breakpoint: window.decathlon.uxBreakpoints.smMin,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });

    /*
     * Display Sizeometer
     *
     */

    $('.sizemeter-resume')
      .on('click', () => {
        if ($(window).width() >= window.decathlon.uxBreakpoints.smMin) {
          $('#details-size-review-content').fadeIn(200);
        } else {
          const detailsSizeReviewContent = $('#details-size-review-content');
          detailsSizeReviewContent.show();
          const positionToScroll = detailsSizeReviewContent.offset().top - 80;
          $.scrollTo(positionToScroll, {
            axis: 'y',
            duration: 200
          });
        }
      })
      .on('mouseleave', () => {
        setTimeout(() => {
          const $detailsSizeReviewContent = $('#details-size-review-content');
          if (!$detailsSizeReviewContent.hasClass('active')) {
            $detailsSizeReviewContent.fadeOut(200);
          }
        }, 200);
      });

    /*
    Display Product reviews
     */
    $('.notation-stars')
      .on('mouseenter mouseover', () => {
        if ($(window).width() >= window.decathlon.uxBreakpoints.smMin) {
          $('#details-review-content').fadeIn(200);
        }
      })
      .on('mouseleave', () => {
        setTimeout(() => {
          const $detailsReviewContent = $('#details-review-content');
          if (!$detailsReviewContent.hasClass('active')) {
            $detailsReviewContent.fadeOut(200);
          }
        }, 200);
      });

    $('#details-review-content')
      .on('mouseenter mouseover', (event) => {
        if (!$(event.currentTarget).hasClass('active')) {
          $(event.currentTarget).addClass('active');
        }
      })
      .on('mouseleave', (event) => {
        setTimeout(() => {
          $(event.currentTarget).fadeOut(200, () => {
            $(event.currentTarget).removeClass('active');
          });
        }, 200);
      });

    /*****************************************************************************************************
     PRODUCT LAYER SETTINGS
     *****************************************************************************************************/
    window.decathlon.tools.selectQuantity($('select.management-amount'));

    /**
     * Close the product modal layout
     * @param  {String} elt Target of click
     */

    // Blocks the click on a next product for 500ms (the transition time) to prevent for exemple : yellow is select in thumbs but red is displayed on the main visual
    $('.thumbs-product-list').on('click', '.model-selection', (event) => {
      $(event.currentTarget).closest('.slick-list').addClass('model-selection-disabled');
      setTimeout(() => {
        $('.thumbs-product-list').find('.slick-list').removeClass('model-selection-disabled');
      }, 500);
    });

    if (makeYourChoiceBtn.length) {
      $(window).on('resize', cube.debounce(() => {
        $.fn.ProductConversionPlugin('updateModalLayoutWidth');
      }, 200));
    }

    /*****************************************************************************************************
     CLOSE LAYOUT
     *****************************************************************************************************/
    const modalExpressPaymentLayout = $('#modal-express-payment-layout');
    modalExpressPaymentLayout.on('click', 'span.back', (event) => {
      if (!$(event.currentTarget).hasClass('back-step')) {

        $('html').attr('data-is-express-checkout', 'false');
        clearQrCodeCheckStatusTimer();

        modalExpressPaymentLayout.removeClass('open');
        modalExpressPaymentLayout.animate({
          right: -document.getElementById('modal-product-layout').offsetWidth - 12
        }, 200, () => {
          modalExpressPaymentLayout.removeAttr('style');
        });
        $.fn.XpressCartPlugin('cancelExpressCheckout');
        $('.fullscreen-layer').hide();
        $('body').removeClass('checkout-layer');
      }
    });

    /*****************************************************************************************************
     TABS ONE CLICK
     *****************************************************************************************************/
    modalExpressPaymentLayout.on('change', 'div.method-option > .radio input', (event) => {
      if ($(event.currentTarget).parents('.radio').siblings('.shipping-method-informations').length > 0) {
        $('div.shipping-method-informations:visible').stop().slideToggle(200);
        $(event.currentTarget).parents('.radio').siblings('.shipping-method-informations').stop().slideToggle(200);
      } else {
        $('#modal-express-payment-layout .shipping-method-informations:visible').stop().slideToggle(200);
      }
    });

    /*****************************************************************************************************
     CORE VERSION - QUANTITY SELECTOR - TODO : BLUR EVENT
     ****************************************************************************************************/
    const quantitySelector = $('.quantity-selector');
    if (parseInt(quantitySelector.find('input').val(), 10) === 1) {
      quantitySelector.find('button.icon-minus').attr('disabled', 'disabled');
    }

    // VIEW VOLUME PRICING
    $('.view-volume-price, #saleByLot').on('click', (event) => {
      //if($(window).width() >= window.decathlon.uxBreakpoints.smMin){
      const sku = $('a#saleByLot').data('sku');
      const skuVolumePriceContent = $('.volume-price-content').filter(`[data-sku='${sku}']`);

      if (!skuVolumePriceContent.hasClass('active')) {
        skuVolumePriceContent.show().animate({
          opacity: 1
        }, 200, () => {
          $(event.currentTarget).addClass('active');
        });
      } else {
        skuVolumePriceContent.stop().animate({
          opacity: 0
        }, 200, () => {
          $(event.currentTarget).hide();
          $(event.currentTarget).removeClass('active');
        });
      }
      //}
    }).on('mouseleave', (event) => {
      const sku = $('a#saleByLot').data('sku');
      const skuVolumePriceContent = $('.volume-price-content').filter(`[data-sku='${sku}']`);

      if (skuVolumePriceContent.hasClass('active')) {
        skuVolumePriceContent.stop().animate({
          opacity: 0
        }, 200, () => {
          $(event.currentTarget).hide();
          $(event.currentTarget).removeClass('active');
        });
      }

    });

    /*****************************************************************************************************
     TOGGLE SHOW/HIDE COLOR
     *****************************************************************************************************/
    mainSlickNavWrapper.on('click', '.toggle-colors', (event) => {
      $(event.currentTarget).parents('.slider-nav-product-visual').toggleClass('open');
    });

    /*****************************************************************************************************
     TABS
     *****************************************************************************************************/
    $('#modal-product-layout .localized').on('click', '.tabs a', (event) => {
      event.preventDefault();
      // go to this element.
      // include the lib
      $('#modal-product-layout').scrollTo('#shipping-wrapper', {
        axis: 'y',
        duration: 500
      });

      if (!$(event.currentTarget).parent('h3').hasClass('disabled')) {
        const tabs = $('#modal-product-layout .localized > div');

        $('#modal-product-layout .localized').find('h3').removeClass('active');

        for (let i = 0; i < tabs.length; i += 1) {

          const t = $(tabs[i]);

          t.removeClass('active');
          if (t.attr('id') === $(event.currentTarget).attr('href').split('#')[1]) {
            t.addClass('active');
            $(event.currentTarget).parent('h3').addClass('active');
          }
        }
      }

    });

    /*****************************************************************************************************
     TABS COLLAPSE EVENTS
     *****************************************************************************************************/
    $('#shipping-information').on('click', 'div.shipping-mode', (event) => {
      const t = $(event.currentTarget);
      const tParent = t.parent('.shipping-type');

      if (tParent.hasClass('selected') && t.next('.shipping-stores-list').length !== 0) {
        tParent.addClass('selected');
      } else {
        tParent.removeClass('selected');
      }
      t.next('ul').stop().slideToggle(200);
    }).on('click', 'ul.shipping-stores-list > li strong, ul.shipping-stores-list > li .icon', (event) => {

      const t = $(event.currentTarget);
      const tParent = t.parent('li');

      const deployedShippingStoresListShippingInformation = $('#shipping-information .shipping-stores-list .deployed');
      if (tParent.hasClass('deployed')) {
        deployedShippingStoresListShippingInformation.find('div.shipping-store-details').stop().slideToggle(200);
        deployedShippingStoresListShippingInformation.removeClass('deployed');
        tParent.addClass('deployed');
      } else {
        tParent.removeClass('deployed');
        deployedShippingStoresListShippingInformation.find('div.shipping-store-details').stop().slideToggle(200);
        deployedShippingStoresListShippingInformation.removeClass('deployed');
      }
      t.siblings('div.shipping-store-details').stop().slideToggle(200);
    });


    $('#shipping-wrapper').on('click', '.stores-located > li > i, .stores-located > li > strong, .stores-located > li > span', (event) => {

      const t = $(event.currentTarget);
      const tParent = t.parent('li');

      const deployedStoresLocatedStockInformation = $('#stock-information .stores-located .deployed');
      if (tParent.hasClass('deployed')) {
        deployedStoresLocatedStockInformation.find('div.shipping-store-details').stop().slideToggle(200);
        deployedStoresLocatedStockInformation.removeClass('deployed');
        tParent.addClass('deployed');
      } else {
        tParent.removeClass('deployed');
        deployedStoresLocatedStockInformation.find('div.shipping-store-details').stop().slideToggle(200);
        deployedStoresLocatedStockInformation.removeClass('deployed');
      }

      t.siblings('div.shipping-store-details').stop().slideToggle(200);

    });

  };

  window.decathlon.product.reinitializeVideoSlickAfterUpdate = (slickVideo) => {
    if ($.fn.slick && slickVideo.find('.video').length > 0) {
      slickVideo.slick({
        dots: true,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        useCSS: true,
        useTransform: true,
        variableWidth: true,
        appendArrows: '#video_container .slick-list'
      });
    }
  };

  window.decathlon.product.addAnalytiContentcUrl = () => {
    const kameleonContentArray = $('.kameleon-content');
    kameleonContentArray.each((index, element) => {
      const urlSource = $(element).attr('data');
      const id = $(element).attr('id');
      let idModel = '';
      if (window.cube.config.anly_useLegacy === 'Y') {
        idModel = CUBE.Analytics.utils.productpage.getSelectedModelId();
      }
      const urlAnalytic = `#advice=advice:product_advice_id-model${idModel}_id-conseil${id}&type=advice`;
      $(element).attr('href', urlSource + urlAnalytic);
    });
  };

  // function specifics to mobile view
  window.decathlon.product.mobileIn = () => {
    const $headerH1 = $('#header-pp').find('h1');

    const copyTheReviewsToTheTop = () => {
      if ($headerH1.siblings('.link-review').length === 0) {
        $headerH1.after($('#conversion-zone').find('.link-review').clone().addClass('visible-xs'));
      }
    };

    if ($headerH1.length === 1) {
      copyTheReviewsToTheTop();
    }

    $('.btn-collapse[aria-expanded]').each((i, btn) => {
      const collapse = $(btn).next('.collapse');

      $(btn).off('click').on('click', event => {
        event.preventDefault();
        $(btn).attr('aria-expanded', collapse.is(':visible'));
        collapse.collapse('toggle');
      });
    });
  };

  // if we leave the mobile view
  window.decathlon.product.mobileOut = () => {
    $('.btn-collapse').off('click.collapse-toggle');
    $('.floor-collapse .collapse').collapse('show');
  };

  // GO !
  const body = $('body');

  if (body.is('.product-page:not(.hero)')) {

    window.decathlon.tools.init();
    window.decathlon.product.init();

    $('.fullscreen-layer').appendTo('body');

    const myGallery = $('#myGallery');
    if (myGallery.length > 0) {
      body.append(myGallery);
    }

    // detect mobile in order to activate / desactivate collapsed floor

    if (window.decathlon.uxBreakpoints.is('small-screen')) {
      window.decathlon.product.mobileIn();
    } else {
      window.decathlon.product.mobileOut();
    }

    $(window).on('enter-small-screen', () => {
      window.decathlon.product.mobileIn();
    });

    $(window).on('exit-small-screen', () => {
      window.decathlon.product.mobileOut();
    });

    // reset after async floor is add
    cube.event.on('async-content:loaded', () => {
      if (window.cube.env.device === 'mobile')
        window.decathlon.product.mobileIn();
      else
        window.decathlon.product.mobileOut();
    });

    /* RESIZE FOR DISPLAY PRODUCT INFORMATIONS - FLUID & TABLET */
    $(window).on('resize-width', cube.debounce(
      () => {
        if ($('#modal-product').is(':visible')) {
          if ($(window).width() > 960) {
            $('#conversion-zone .product-informations').show();
          }
          if ($(window).width() < 960) {
            $('#conversion-zone .product-informations').hide();
          }
        }

      }, 100));

    body.on('shown.bs.collapse', (event) => {
      window.decathlon.tools.refreshAllSlicksInTheContainer($(event.target));
    });

    const containerFloorAmbiencePictures = $('#container-floor-ambience div.slick-pp-pictures-img');

    containerFloorAmbiencePictures.on('init reInit', () => {
      setTimeout(() => {
        containerFloorAmbiencePictures.slick('setPosition');
      }, 500);
    });

    containerFloorAmbiencePictures.slick({
      centerMode: true,
      useCSS: true,
      useTransform: true,
      variableWidth: true,
      responsive: [{
        breakpoint: window.decathlon.uxBreakpoints.smMin,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
    // init Advices
    window.decathlon.product.addAnalytiContentcUrl();

    const initPDPAdvicesSlider = () => {
      $('.PDPAdvices-slider').slick({
        dots: true,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: cube.constants.breakpointSm,
            settings: 'unslick'
          }
        ]
      });
    };

    const checkAdviceSlickNeed = () => {
      const pdpAdvicesSlider = $('.PDPAdvices-slider');
      if ((!cube.ui.isMobile()) && (pdpAdvicesSlider.length) && !pdpAdvicesSlider.hasClass('slick-initialized')) {
        initPDPAdvicesSlider();
      }
    };

    $(window).on('resize', cube.debounce(checkAdviceSlickNeed, 300));
    checkAdviceSlickNeed();

    // call instance for dynamic navigation
    cube.$$('a[href="#ReviewsFloor"]').on('click', event => {
      event.preventDefault();
      event.stopPropagation();

      const reviewFloor = cube.$id('ReviewsFloor');

      const headerHeight = Math.max(cube.$('.m-header-main').offsetHeight, cube.$('.product-head').offsetHeight);
      const navbarHeight = cube.$('.description-product-nav').offsetHeight;

      cube.ui.smoothScroll(reviewFloor, { offset: -(headerHeight + navbarHeight) });
    });

    // This condition is to hide the internal navigation picture option if the model has one image. It is put here because the code in the internal navigation needs to be rendered to be hidden
    if ($('.floor-pictures').find('a[data-dynamic-nav*=\'floor_pictures\']').data('imagesNumber') < 2) {
      $('ul.container-floor').find('li a[href*=\'floor_pictures\']').hide();
    }

    body.append($('#modal-product-layout'));
    body.append($('#modal-express-payment-layout'));
    body.append($('#location-modal'));
  }

  //TODO override myGallery with the link from JSON


  // link review
  $(document).on('click touchend', 'a[href^="#container-floor-review"]', (event) => {
    const the_id = $(event.currentTarget).attr('href');

    $('html, body').animate({
      scrollTop: $(the_id).offset().top - $('.product-head').outerHeight()
    }, 'slow');

    if (window.decathlon.uxBreakpoints.is('small-screen')) {
      $(the_id).find('.collapse').first().collapse('show');
      $(the_id).find('.btn-collapse').attr('aria-expanded', 'true');
    }

    return false;

  });

}



// WEBPACK FOOTER //
// ./src/catalog/product.js